export default __webpack_public_path__ + "static/media/en.86fa8427.svg";